export DynamicView from 'yxyweb/common/components/portal/DynamicView'
export BasicTest from 'yxyweb/common/components/basic-test';



// WEBPACK FOOTER //
// ./src/common/components/index.jsx